import(/* webpackMode: "eager" */ "/workspace/pkgs/apps/a-tm/src/app/(fullPage)/(postMain)/article/labels/error.tsx");
